import React, { } from 'react';
import { Form, Input } from 'antd';




const { TextArea } = Input;


export default function VikhodIzPari(props) {
    const { object } = props;
    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                paraID: object.ID
            }}
        >
            <Form.Item
                preserve={"true"}
                hidden={true}
                name={"paraID"}
                label={"Пара"}
                rules={[{ required: true, message: 'Укажите пару!' }]}
            >
                <Input disabled />
            </Form.Item>
            <Form.Item
                name={"prichinaVikhodaTekst"}
                label={"Причина"}
                rules={[{ required: true, message: 'Укажите причину!' }]}
            >
                <TextArea rows={4} />
            </Form.Item>
        </Form>
    );
}
